import { motion } from 'motion/react';
import React, { useEffect, useRef, useState } from 'react';

interface ScrollManagerProps {
  messagesEndRef: React.RefObject<HTMLDivElement>;
  onViewportEnter: () => void;
  onViewportLeave: () => void;
  children: React.ReactNode;
  containerRef?: React.RefObject<HTMLDivElement>;
}

export const ScrollManager: React.FC<ScrollManagerProps> = ({
  messagesEndRef,
  onViewportEnter,
  onViewportLeave,
  children,
  containerRef,
}) => {
  const [scrollableContainer, setScrollableContainer] =
    useState<HTMLElement | null>(null);
  const scrollableContainerRef = useRef<HTMLElement | null>(null);

  // Find the scrollable container (parent with overflow-y-auto)
  useEffect(() => {
    if (containerRef?.current) {
      let parent = containerRef.current.parentElement;
      while (parent && parent !== document.body) {
        const computedStyle = window.getComputedStyle(parent);
        if (
          computedStyle.overflowY === 'auto' ||
          computedStyle.overflowY === 'scroll' ||
          computedStyle.overflow === 'auto' ||
          computedStyle.overflow === 'scroll'
        ) {
          scrollableContainerRef.current = parent;
          setScrollableContainer(parent);
          break;
        }
        parent = parent.parentElement;
      }
    }
  }, [containerRef]);

  return (
    <>
      {children}
      {/* Scroll anchor with motion - scoped to chat container viewport */}
      <motion.div
        ref={messagesEndRef}
        className="bitte-shrink-0 bitte-min-w-[24px] bitte-min-h-[24px]"
        onViewportEnter={onViewportEnter}
        onViewportLeave={onViewportLeave}
        viewport={{
          root: scrollableContainer ? scrollableContainerRef : undefined,
          margin: '0px 0px -50px 0px', // Trigger when 50px from bottom
        }}
      />
    </>
  );
};
